import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../Containers/Config/index.js';
import { CUSTOMER_360_PAIN_MINUTES, CUSTOMER_360_PAIN_MINUTES_ERROR, CUSTOMER_360_PAIN_MINUTES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* customer360PainMinutes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: CUSTOMER_360_PAIN_MINUTES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CUSTOMER_360_PAIN_MINUTES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CUSTOMER_360_PAIN_MINUTES_ERROR, payload: error });
  }
}

export function* watchCustomer360PainMinutes() {
  yield takeEvery(CUSTOMER_360_PAIN_MINUTES, customer360PainMinutes);
}

function* customer360PainMinutesSaga() {
  yield all([fork(watchCustomer360PainMinutes)]);
}

export default customer360PainMinutesSaga;
